module.exports = __webpack_public_path__ + "img/zanting.9fa23e6e.png";